<template lang="pug">
div(ref='art' class='art')
</template>

<script>
import * as d3 from 'd3'
import colors from 'vuetify/es5/util/colors'

const fontPercentage = 30

function getBoundingBoxCenter(selection) {
  let element = selection.node()
  let bbox = element.getBBox()
  return [bbox.x + bbox.width / 2, bbox.y + bbox.height / 2]
}

function findPolygonWidth(vertices) {
  let minX = Number.MAX_VALUE
  let maxX = Number.MIN_VALUE
  for (let i = 0; i < vertices.length; i++) {
    let x = vertices[i][0]
    if (x < minX) {
      minX = x
    }
    if (x > maxX) {
      maxX = x
    }
  }
  return maxX - minX
}

function calcAverage(array) {
  return array.length > 0
    ? array.reduce((total, num) => total + num) / array.length
    : 0
}

// function calcPolygonArea(vertices) {
//   var area = 0;
//   var j = vertices.length - 1;
//   for (var i = 0; i < vertices.length; i++) {
//     area += (vertices[j][0] + vertices[i][0]) * (vertices[j][1] - vertices[i][1]);
//     j = i;
//   }
//   return Math.abs(area / 2);
// }

const defaultViewBox = '0 0 720 540'

export default {
  data: () => ({
    scale: 1
  }),
  props: {
    placements: Array,
    scheme: String,
    viewBox: {
      // TODO: по дефолту юзаем такой viewbox
      default: defaultViewBox
    },
    itemId: {
      type: String,
      default: 'uuid'
    },
    itemPoints: {
      type: String,
      default: 'points'
    }
  },

  destroyed() {
    if (this.art) {
      this.art.remove()
      this.art = null
    }
  },

  mounted() {
    this.art = d3
      .select(this.$refs.art)
      .append('svg')
      .attr('width', '100%')
      .attr('height', '100%')
      // По дефолту устанавливаем view_box, который ранее был для всех обводок
      .attr('viewBox', this.viewBox ? this.viewBox : defaultViewBox)


    this.container = this.art.append('g')

    this.enableZoom()
    this.createPolygons()
    this.createScheme()
  },

  methods: {
    enableZoom() {
      const g = this.container

      const sizes = (this.viewBox || defaultViewBox).split(/\s/)
      const width = sizes[2]
      const height = sizes[3]

      const zoom = d3.behavior.zoom()
        .scaleExtent([1, 50])
        .on("zoom", function () {
          const e = d3.event
          const tx = Math.min(0, Math.max(e.translate[0], width - width * e.scale))
          const ty = Math.min(0, Math.max(e.translate[1], height - height * e.scale))

          zoom.translate([tx, ty])

          g.attr("transform", [
            "translate(" + [tx, ty] + ")",
            "scale(" + e.scale + ")"
          ].join(" "))
        })

      this.art.call(zoom)
    },

    createPolygons() {
      this.container.selectAll('g').remove()

      this.fontSizes || (this.fontSizes = [])
      this.placements.forEach(placement => {
        if (null === placement.points) {
          return
        }
        const vertices = placement[this.itemPoints]
        const polyWidth = findPolygonWidth(vertices)
        // запишем все абсолютные размеры текста
        // дабы потом усредница
        this.fontSizes.push((fontPercentage / 100) * polyWidth)
      })

      this.avgFontSize = calcAverage(this.fontSizes)

      this.placements.forEach(this.polygonCreator)
    },

    polygonCreator(placement) {
      if (null === placement.points) {
        return
      }

      let g = this.container.append('g')
      let polygon = g.append('polygon')

      polygon
        .attr('points', placement[this.itemPoints])
        .style('fill', colors.green.base)
        .attr('fill-opacity', 0.3)
        .attr('stroke', colors.green.base)

      let [pcx, pcy] = getBoundingBoxCenter(polygon)

      g.append('circle')
        .attr('r', 39)
        .attr('fill', 'transparent')
        .attr('cx', pcx)
        .attr('cy', pcy)

      let placeNumber = this.placements.findIndex(x => x.id === placement.id) + 1

      let fontSize = this.avgFontSize

      let deltaY = fontSize / 2
      let deltaX = placeNumber < 10 ? (fontSize / 3) : deltaY

      g.append('text')
        .attr('x', pcx - deltaX)
        .attr('y', pcy + deltaY)
        .attr('font-weight', 'bolder')
        .attr('font-family', 'inherit')
        .attr('font-size', fontSize)
        .attr('opacity', 1)
        .attr('fill', '#ff0000')
        // TODO: не работает в Chrome
        .attr('vector-effect', 'non-scaling-size')
        .attr('webkit-font-size-adjust', 1)
        // eof
        .text(placeNumber)
    },

    createScheme() {
      this.container.select('.image').remove()
      this.container
        .insert('svg:image', ':first-child')
        .attr('xlink:href', this.scheme)
        .attr('x', 0)
        .attr('y', 0)
        .attr('class', 'image')
        .attr('width', '100%')
        .attr('height', '100%')
    }
  },

  watch: {
    placements: 'createPolygons',
    scheme: 'createScheme'
  }
}
</script>

<style scoped>
.art {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  pointer-events: all;
}
</style>
